module.exports = __webpack_public_path__ + "images/external_images/img/855x465/img1.jpg";